import { EventRequest, SendRequestDTO } from '../types';
import { axiosInstance, endpoints } from '../utils/axios';

export async function sendRequest(eventId: string, payload: SendRequestDTO): Promise<EventRequest> {
  const response = await axiosInstance.post<EventRequest>(
    endpoints.eventRequests.sendRequest(eventId),
    payload
  );
  return response.data;
}
